export const wizardMessages = {
  en: {
    wizard: {
      // Stepper labels
      step1: 'IT Infrastructure Base',
      step2: 'Network & Security Infrastructure',
      step3: 'Security Solutions for Identity & Endpoints',
      step4: 'Custom Use Cases',
      step4Placeholder: 'Content — Custom Use Cases',

      // InfrastrukturBasis (Step 1)
      infraTitle: 'Your IT Infrastructure as the Foundation',
      infraDescription:
        'Define your IT infrastructure as the basis for perfectly tailored workflows. Select whether your servers are operated locally, in the cloud, or in a hybrid setup. Specify which operating systems you use on servers and clients. If your environment has special requirements, you can add custom configurations. Based on your inputs, we automatically create workflows that match your infrastructure — efficient, flexible, and future-proof.',
      legendServerInfra: 'Server Infrastructure',
      legendServerOS: 'Server Operating Systems',
      legendClientOS: 'Client Operating Systems',
      otherInfra: 'Other infrastructure (if not listed):',
      otherServerOS: 'Other server operating systems:',
      otherClientOS: 'Other client operating systems (if not listed):',
      phServerInfra: 'Enter infrastructure name',
      phOS: 'Enter operating system name',

      // InfrastrukturInternal (Step 2)
      networkTitle: 'Define Network & Security Infrastructure',
      networkDescription:
        'Define the central infrastructure of your network to receive perfectly tailored workflows. Select the firewall systems, switches, and WLAN solutions in use, or add individual systems. Your information helps create customized automations for a secure and high-performance IT environment.',
      legendFirewall: 'Firewall Systems',
      legendSwitch: 'Switch Infrastructure',
      legendWlan: 'WLAN Infrastructure',
      legendPlatforms: 'Platforms',
      otherFirewall: 'Other firewall (if not listed):',
      otherSwitch: 'Other switch solution (if not listed):',
      otherWlan: 'Other WLAN solution (if not listed):',
      otherPlatform: 'Other platform (if not listed):',
      phFirewall: 'Enter firewall name',
      phSwitch: 'Enter switch infrastructure name',
      phWlan: 'Enter WLAN solution name',
      phPlatform: 'Enter platform name',

      // SecurityMaßnahmen (Step 3)
      securityTitle: 'Security Solutions for Identity & Endpoints',
      securityDescription:
        'Select the authentication solutions and Endpoint Detection & Response (EDR) systems used in your IT environment. This information helps us create tailored workflows that optimally support your security strategy. If your solution is not listed, you can add it individually.',
      legendAuth: 'Authentication Solutions',
      legendEdr: 'EDR Systems (Endpoint Detection & Response)',
      otherAuth: 'Other solution (if not listed):',
      otherEdr: 'Other EDR solution (if not listed):',
      phAuth: 'Enter solution name',
      phEdr: 'Enter EDR solution name',
    },
  },
  de: {
    wizard: {
      step1: 'IT-Infrastruktur Basis',
      step2: 'Netzwerk- & Sicherheitsinfrastruktur',
      step3: 'Sicherheitslösungen für Identität & Endgeräte',
      step4: 'Individuelle Use Cases',
      step4Placeholder: 'Inhalt – Individuelle Use Cases',

      infraTitle: 'Deine IT-Infrastruktur als Basis',
      infraDescription:
        'Bestimme deine IT-Infrastruktur als Grundlage für perfekt zugeschnittene Workflows. Wähle aus, ob deine Server lokal, in der Cloud oder hybrid betrieben werden. Gib an, welche Betriebssysteme du auf Servern und Clients nutzt. Falls deine Umgebung spezielle Anforderungen hat, kannst du individuelle Konfigurationen ergänzen. Basierend auf deinen Eingaben erstellen wir automatisierte Workflows, die genau zu deiner Infrastruktur passen – effizient, flexibel und zukunftssicher.',
      legendServerInfra: 'Server-Infrastruktur',
      legendServerOS: 'Server-Betriebssysteme',
      legendClientOS: 'Client-Betriebssysteme',
      otherInfra: 'Andere Infrastruktur (falls nicht gelistet):',
      otherServerOS: 'Andere Server-Betriebssysteme:',
      otherClientOS: 'Andere Betriebssysteme (falls nicht gelistet):',
      phServerInfra: 'Name der Infrastruktur eingeben',
      phOS: 'Name des Betriebssystems eingeben',

      networkTitle: 'Netzwerk- & Sicherheitsinfrastruktur festlegen',
      networkDescription:
        'Definiere die zentrale Infrastruktur deines Netzwerks, um perfekt abgestimmte Workflows zu erhalten. Wähle die eingesetzten Firewall-Systeme, Switches und WLAN-Lösungen aus, oder ergänze individuelle Systeme. Deine Angaben helfen dabei, maßgeschneiderte Automatisierungen für eine sichere und leistungsfähige IT-Umgebung zu erstellen.',
      legendFirewall: 'Firewall-Systeme',
      legendSwitch: 'Switch-Infrastruktur',
      legendWlan: 'WLAN-Infrastruktur',
      legendPlatforms: 'Plattformen',
      otherFirewall: 'Andere Firewall (falls nicht gelistet):',
      otherSwitch: 'Andere Switch-Lösung (falls nicht gelistet):',
      otherWlan: 'Andere WLAN-Lösung (falls nicht gelistet):',
      otherPlatform: 'Andere Plattform (falls nicht gelistet):',
      phFirewall: 'Name der Firewall eingeben',
      phSwitch: 'Name der Switch-Infrastruktur eingeben',
      phWlan: 'Name der WLAN-Lösung eingeben',
      phPlatform: 'Name der Plattform eingeben',

      securityTitle: 'Sicherheitslösungen für Identität & Endgeräte',
      securityDescription:
        'Wähle die Authentifizierungslösungen und Endpoint-Detection-&-Response-(EDR)-Systeme aus, die in deiner IT-Umgebung eingesetzt werden. Diese Informationen helfen uns, maßgeschneiderte Workflows zu erstellen, die deine Sicherheitsstrategie optimal unterstützen. Falls deine Lösung nicht gelistet ist, kannst du sie individuell hinzufügen.',
      legendAuth: 'Authentifizierungslösungen',
      legendEdr: 'EDR-Systeme (Endpoint Detection & Response)',
      otherAuth: 'Andere Lösung (falls nicht gelistet):',
      otherEdr: 'Andere EDR-Lösung (falls nicht gelistet):',
      phAuth: 'Name der Lösung eingeben',
      phEdr: 'Name der EDR-Lösung eingeben',
    },
  },
}
